export default (store) => {
    const $http = store.ng.injector.get('$http');
    const locale = store.ng.injector.get('locale');
    const Alert = store.ng.injector.get('Alert');
    const SweetAlert = store.ng.injector.get('SweetAlert');
    const Translate = store.ng.injector.get('$translate');

    return locale.ready('sweetalerts').then(() => {
        const translatedValue = (path) => {
            return Translate.instant(`store.base.actions.ask-to-restore-records.${path}`);
        };

        Alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content'),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
                wait: true
            },
        ).then(() => {
                return $http.put(store.getters.slug + '/restore', {
                    items: store.getters.selectedFilters
                }).then(() => {
                    SweetAlert.close();
                    Alert.success(locale.getString('sweetalerts.restore_successful'), locale.getString('sweetalerts.records_restored_message'));
                    Alert.hide();
                    return store.dispatch('getData')
                }, response => {
                    Alert.handle(response);
                })
            });
        }
    );
}



// WEBPACK FOOTER //
// ./src/app/store/base/actions/restore-many.js